import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import ImpContainer from '../ImpContainer/ImpContainer';
const glowHeight = 300;
const glowWidth = 300;
const glowBorderRadius = 150;
const maxRotationLeftRight = 9;
const maxRotationUpDown = 7;
const HoverableWrapper = styled.div `
  display: inline-block;
  position: relative;
  ${(props) => props.borderRadius && `border-radius: ${props.borderRadius}px`};
  transition-duration: 300ms;
  transition-property: transform, box-shadow;
  transition-timing-function: ease-out;
  overflow: hidden;

  box-shadow: 0px 4px 16px -4px rgba(0, 0, 0, 0.25);

  img {
    display: block;
  }

  &:hover {
    transition-duration: 150ms;
    box-shadow: 0px 32px 64px -16px rgba(0, 0, 0, 0.25);
  }
`;
const Glow = styled.div `
  pointer-events: none;
  position: absolute;
  border-radius: ${glowBorderRadius}px;
  height: ${glowHeight}px;
  width: ${glowWidth}px;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.15) 20%,
    rgba(255, 255, 255, 0.1) 40%,
    rgba(255, 255, 255, 0.02) 60%,
    rgba(255, 255, 255, 0.0001) 80%,
    transparent 100%
  );

  pointer-events: none;
`;
export default function ImpHoverable({ children, borderRadius, }) {
    const cardRef = useRef(null);
    const [boxPosition, setBoxPosition] = useState({ x: 0, y: 0 });
    const [boxVisible, setBoxVisible] = useState(false);
    useEffect(() => {
        const card = cardRef.current;
        if (!card)
            return;
        let bounds;
        function rotateToMouse(e) {
            const mouseX = e.clientX;
            const mouseY = e.clientY;
            const boxX = e.clientX - bounds.x;
            const boxY = e.clientY - bounds.y;
            const boxYAdjusted = boxY - glowHeight / 2;
            const boxXAdjusted = boxX - glowWidth / 2;
            const leftX = mouseX - bounds.x;
            const topY = mouseY - bounds.y;
            const center = {
                x: leftX - bounds.width / 2,
                y: topY - bounds.height / 2,
            };
            setBoxPosition({ x: boxXAdjusted, y: boxYAdjusted });
            const rotationUpDown = (center.y / bounds.height) * maxRotationUpDown;
            const rotationLeftRight = (center.x / bounds.width) * maxRotationLeftRight;
            card.style.transform = `perspective(1000px) rotateX(${-rotationUpDown}deg) rotateY(${rotationLeftRight}deg)`;
        }
        const handleMouseEnter = () => {
            setBoxVisible(true);
            bounds = card.getBoundingClientRect();
            document.addEventListener('mousemove', rotateToMouse);
        };
        const handleMouseLeave = () => {
            setBoxVisible(false);
            document.removeEventListener('mousemove', rotateToMouse);
            card.style.transform = '';
        };
        // Event listeners
        card.addEventListener('mouseenter', handleMouseEnter);
        card.addEventListener('mouseleave', handleMouseLeave);
        return () => {
            card.removeEventListener('mouseenter', handleMouseEnter);
            card.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);
    return (React.createElement(HoverableWrapper, { ref: cardRef, borderRadius: borderRadius },
        React.createElement(ImpContainer, null, children),
        boxVisible && (React.createElement(Glow, { style: { top: `${boxPosition.y}px`, left: `${boxPosition.x}px` } }))));
}
//# sourceMappingURL=ImpHoverable.js.map